import { LayerType } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-animations/element-animation/anim-constants';
import { DisplayObject } from '@tencent/alloy-renderer';

export type IRectangle = {
    x: number;
    y: number;
    width: number;
    height: number;
};

/**
 * 获取元素Canvas入口
 */
export enum CanvasEntry {
    edit = 'edit',   // 中间编辑区
    list = 'list',  // 左侧列表页
    operation = 'operation',  // 操作区
    note = 'note',  // 备注
    player = 'player',  // 播放页
    paragraphPreview = 'paragraph-preview', // 段落格式面板预览
    layoutEdit = 'layout-edit',  // 母版板式编辑区
}

export type Cursor = CSSStyleDeclaration['cursor'];

export type IndexType = number | number[] | 'current' | 'all';

/**
 * canvas中组件定位
 */
export type CanvasLocator = {
    /**
     * 获取canvas的入口。默认为'edit'
     */
    entry?: CanvasEntry,
    /**
     * 指定parentId会在parent下查找组件
     */
    parentId?: string;
    /**
     * 可以给统一渲染层组件设置id。用于查找元素。id模糊匹配
     */
    id?: string;

    /**
     * slide索引位置，不传默认为查找current
     */
    slideIndex?: IndexType;

    /**
     * 返回多个结果时，匹配对应索引
     */
    findIndex?: number | number[];

    /**
     * 允许调用方可以进行最后一次过滤
     * @param elements
     */
    customizer?: (views: DisplayObject[]) => DisplayObject[];

    // 演示态分层渲染：当前元素层、操作层、覆盖层
    layerType?: LayerType
};
